import BaseTabMenu from "../../sisu/menu/BaseTabMenu.sisu";
export default BaseTabMenu;